module.exports = __webpack_public_path__ + "static/img/水資源統計.4b3c87d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/水資源統計.jpg
// module id = Cww8
// module chunks = 1